// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* =========================
   產品篩選彈層
========================= */
.filter-popover.panel {
  background: #fff !important;
  border: 1px solid #ddd !important;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.2);
}

.filter-popover .list-group-item {
  background: #fff !important;
  border-color: #eee;
}

@media (max-width: 768px) {
  .filter-popover.panel {
    width: 90vw !important;
    left: auto !important;
    right: 0 !important;
  }
}
/* =========================
   可展開列
========================= */
.table .row-toggle {
  cursor: pointer;
  transition: background-color 0.2s ease;
}

/* Bootstrap table-striped 要改 td，不是 tr */
.table.table-striped tbody tr.row-toggle:hover > td {
  background-color: #eef5ff !important;
}

/* 鍵盤 Focus */
.table .row-toggle:focus {
  outline: 2px solid #5bc0de;
  outline-offset: -2px;
}

/* =========================
   展開箭頭
========================= */
.caret-rotate {
  display: inline-block;
  transition: transform 0.2s ease;
}

.caret-rotate.open {
  transform: rotate(180deg);
}

/* =========================
   展開內容
========================= */
tr.row-details > td {
  background: #fcfcfc;
  border-top: none;
}

/* ======================================================
   訂單篩選 Select
====================================================== */
.order-filter-select {
  min-width: 130px;
  color: #333 !important;
  background-color: #fff !important;
  -webkit-text-fill-color: #333 !important;
}

.order-filter-select option {
  color: #333 !important;
  background-color: #fff !important;
  -webkit-text-fill-color: #333 !important;
}

/* ======================================================
   訂單狀態 Select
====================================================== */
.order-status-select {
  min-width: 90px;
  color: #333 !important;
  background-color: #fff !important;
  -webkit-text-fill-color: #333 !important;
}

.order-status-select option {
  color: #333 !important;
  background-color: #fff !important;
  -webkit-text-fill-color: #333 !important;
}

/* focus 時仍維持正常文字 */
.order-filter-select:focus,
.order-status-select:focus {
  color: #333 !important;
  background-color: #fff !important;
  -webkit-text-fill-color: #333 !important;
}

/* ======================================================
   篩選列
====================================================== */
.order-filter-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}

/* ======================================================
   產品篩選 popup
====================================================== */
.filter-popover {
  color: #333;
  background: #fff;
}

.filter-popover .list-group-item {
  color: #333;
  background: #fff;
}

.filter-popover label {
  color: #333;
}

/* ======================================================
   手機 / 小螢幕
====================================================== */
@media (max-width: 768px) {
  .order-filter-bar {
    width: 100%;
    display: block;
  }
  .order-filter-bar .form-group {
    display: block;
    margin-right: 0 !important;
    margin-bottom: 10px;
  }
  .order-filter-select {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/admorder/style/admorder.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;2BAAA;AAIA;EACI,2BAAA;EACA,iCAAA;EACA,yCAAA;AACJ;;AAEA;EACI,2BAAA;EACA,kBAAA;AACJ;;AAEA;EACI;IACI,sBAAA;IACA,qBAAA;IACA,mBAAA;EACN;AACF;AAEA;;2BAAA;AAIA;EACI,eAAA;EACA,sCAAA;AADJ;;AAIA,wCAAA;AACA;EACI,oCAAA;AADJ;;AAIA,aAAA;AACA;EACI,0BAAA;EACA,oBAAA;AADJ;;AAIA;;2BAAA;AAIA;EACI,qBAAA;EACA,+BAAA;AAFJ;;AAKA;EACI,yBAAA;AAFJ;;AAKA;;2BAAA;AAIA;EACI,mBAAA;EACA,gBAAA;AAHJ;;AAMA;;wDAAA;AAIA;EACE,gBAAA;EACA,sBAAA;EACA,iCAAA;EACA,wCAAA;AAJF;;AAOA;EACE,sBAAA;EACA,iCAAA;EACA,wCAAA;AAJF;;AAQA;;wDAAA;AAIA;EACE,eAAA;EACA,sBAAA;EACA,iCAAA;EACA,wCAAA;AANF;;AASA;EACE,sBAAA;EACA,iCAAA;EACA,wCAAA;AANF;;AAUA,mBAAA;AACA;;EAEE,sBAAA;EACA,iCAAA;EACA,wCAAA;AAPF;;AAWA;;wDAAA;AAIA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,QAAA;AATF;;AAaA;;wDAAA;AAIA;EACE,WAAA;EACA,gBAAA;AAXF;;AAcA;EACE,WAAA;EACA,gBAAA;AAXF;;AAcA;EACE,WAAA;AAXF;;AAeA;;wDAAA;AAIA;EACE;IACE,WAAA;IACA,cAAA;EAbF;EAgBA;IACE,cAAA;IACA,0BAAA;IACA,mBAAA;EAdF;EAiBA;IACE,WAAA;EAfF;AACF","sourcesContent":["/* =========================\r\n   產品篩選彈層\r\n========================= */\r\n\r\n.filter-popover.panel {\r\n    background: #fff !important;\r\n    border: 1px solid #ddd !important;\r\n    box-shadow: 0 6px 18px rgba(0, 0, 0, .2);\r\n}\r\n\r\n.filter-popover .list-group-item {\r\n    background: #fff !important;\r\n    border-color: #eee;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .filter-popover.panel {\r\n        width: 90vw !important;\r\n        left: auto !important;\r\n        right: 0 !important;\r\n    }\r\n}\r\n\r\n/* =========================\r\n   可展開列\r\n========================= */\r\n\r\n.table .row-toggle {\r\n    cursor: pointer;\r\n    transition: background-color .2s ease;\r\n}\r\n\r\n/* Bootstrap table-striped 要改 td，不是 tr */\r\n.table.table-striped tbody tr.row-toggle:hover > td {\r\n    background-color: #eef5ff !important;\r\n}\r\n\r\n/* 鍵盤 Focus */\r\n.table .row-toggle:focus {\r\n    outline: 2px solid #5bc0de;\r\n    outline-offset: -2px;\r\n}\r\n\r\n/* =========================\r\n   展開箭頭\r\n========================= */\r\n\r\n.caret-rotate {\r\n    display: inline-block;\r\n    transition: transform .2s ease;\r\n}\r\n\r\n.caret-rotate.open {\r\n    transform: rotate(180deg);\r\n}\r\n\r\n/* =========================\r\n   展開內容\r\n========================= */\r\n\r\ntr.row-details > td {\r\n    background: #fcfcfc;\r\n    border-top: none;\r\n}\r\n\r\n/* ======================================================\r\n   訂單篩選 Select\r\n====================================================== */\r\n\r\n.order-filter-select {\r\n  min-width: 130px;\r\n  color: #333 !important;\r\n  background-color: #fff !important;\r\n  -webkit-text-fill-color: #333 !important;\r\n}\r\n\r\n.order-filter-select option {\r\n  color: #333 !important;\r\n  background-color: #fff !important;\r\n  -webkit-text-fill-color: #333 !important;\r\n}\r\n\r\n\r\n/* ======================================================\r\n   訂單狀態 Select\r\n====================================================== */\r\n\r\n.order-status-select {\r\n  min-width: 90px;\r\n  color: #333 !important;\r\n  background-color: #fff !important;\r\n  -webkit-text-fill-color: #333 !important;\r\n}\r\n\r\n.order-status-select option {\r\n  color: #333 !important;\r\n  background-color: #fff !important;\r\n  -webkit-text-fill-color: #333 !important;\r\n}\r\n\r\n\r\n/* focus 時仍維持正常文字 */\r\n.order-filter-select:focus,\r\n.order-status-select:focus {\r\n  color: #333 !important;\r\n  background-color: #fff !important;\r\n  -webkit-text-fill-color: #333 !important;\r\n}\r\n\r\n\r\n/* ======================================================\r\n   篩選列\r\n====================================================== */\r\n\r\n.order-filter-bar {\r\n  display: flex;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n  gap: 6px;\r\n}\r\n\r\n\r\n/* ======================================================\r\n   產品篩選 popup\r\n====================================================== */\r\n\r\n.filter-popover {\r\n  color: #333;\r\n  background: #fff;\r\n}\r\n\r\n.filter-popover .list-group-item {\r\n  color: #333;\r\n  background: #fff;\r\n}\r\n\r\n.filter-popover label {\r\n  color: #333;\r\n}\r\n\r\n\r\n/* ======================================================\r\n   手機 / 小螢幕\r\n====================================================== */\r\n\r\n@media (max-width: 768px) {\r\n  .order-filter-bar {\r\n    width: 100%;\r\n    display: block;\r\n  }\r\n\r\n  .order-filter-bar .form-group {\r\n    display: block;\r\n    margin-right: 0 !important;\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .order-filter-select {\r\n    width: 100%;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
